import React from "react";
import { Col, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Formik, Field, ErrorMessage } from "formik";
import { BasicsProfilevalidationSchema } from "../../utils/Validations";
import { useMutation } from "@tanstack/react-query";
import { putRequest } from "../../services/apiMethods";
import { companySizeOptions, companytype, LimitedCompanyOptions } from "../../utils/commanFiles";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import useImageUploader from "../../hooks/UploadImage";
import toast from "react-hot-toast";
import Spinner from 'react-bootstrap/Spinner';


const modules = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // Basic formatting
    [{ list: "ordered" }, { list: "bullet" }],
    // ["link", "image"], // Link & Image options
    ["clean"], // Remove formatting
  ],
};
const BasicsProfile = ({ data: existData, refresh }) => {

  const { uploadImage, loading, error, uploadedUrl, errorMessage } = useImageUploader();  // Call the hook here
  const initialValues = {
    bussinessName: existData?.bussinessName || "",
    companySize: existData?.companySize || "",
    companyType: existData?.companyType || "",
    incorporationDate: existData?.incorporationDate?.split("T")[0] || "",
    description: existData?.description || "",
    image: (existData?.image) || (uploadedUrl ? uploadedUrl : ""),
  };


  const { mutate, isLoading: apiState } = useMutation({
    mutationFn: (data) => {
      let modifyData
      if (existData?.incorporationDate && existData?.description) {
        modifyData = {
          bussinessName: data?.bussinessName || "",
          companySize: data?.companySize || "",
          companyType: data?.companyType || "",

          incorporationDate: data?.incorporationDate?.split("T")[0] || "",
          description: data?.description || "",
          image: data?.image || "",
        }
      } else {
        modifyData = {
          bussinessName: data?.bussinessName || "",
          companySize: data?.companySize || "",
          companyType: data?.companyType || "",
          incorporationDate: data?.incorporationDate?.split("T")[0] || "",
          description: data?.description || "",
          image: data?.image || "",
          percentage: existData?.percentage + 30
        }
      }
      return putRequest(`/profile/edit`, modifyData);
    },
    onSuccess: (data) => {
      toast.success(`${data?.message}`, {
        iconTheme: {
          primary: '#337FE0',
          secondary: '#FFFAEE',
        },
      })
      refresh()
    },
    onError: (error) => {
      console.error("Error during API call:", error);
    },
  });


  const handleSubmit = (values) => {
    mutate(values);
  };

  return (
    <div className="my-profile-box-contain">
      <div className="my-profile-box-form">
        <div className="h-100 m-0">
          <div className="form-box-title">
            <h4>Basics</h4>
            <p>Introduce your company to your clients</p>
          </div>
          <Formik
            initialValues={initialValues}
            enableReinitialize={true}
            validationSchema={BasicsProfilevalidationSchema}
            onSubmit={handleSubmit}
          >
            {({ handleSubmit, setFieldValue, values }) => (
              <Form className="cmn-form-set" onSubmit={handleSubmit}>
                <Form.Group className="mb-3" controlId="formBasicEmail">
                  <Form.Label>Company Logo</Form.Label>
                  <div className="cmpny-logo-upld">

                    {loading ?
                      <span className="dot">
                        <Spinner as="span" animation="border" variant="primary" size="sm" role="status" aria-hidden="true" />
                      </span>

                      :
                      <img
                        src={values?.image ? values?.image : require("../../assets/images/vector-logo.svg").default}
                        alt="Company Logo"
                      />
                    }
                    <div>
                      <div className="cmpny-logo-upld">
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={async (event) => {
                            const file = event.target.files[0];
                            if (file) {
                              await uploadImage(file); // Wait for image upload
                              setFieldValue("image", uploadedUrl); // Set the uploaded image URL
                            }
                          }}
                        />
                        <button type="button" className="white-btn" disabled={loading}>
                          Upload Photo
                        </button>
                      </div>
                      <ErrorMessage
                        name="image"
                        component="div"
                        className="text-danger"
                      />
                    </div>
                  </div>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label>Business Name</Form.Label>
                  <Field
                    name="bussinessName"
                    type="text"
                    onChange={(e) => {
                      setFieldValue("bussinessName", e.target.value.replace(/^\s+/, "")); // Trim leading spaces
                     }}
                    placeholder="Lloyd’s Electrics"
                    className="form-control"
                  />
                  <ErrorMessage
                    name="bussinessName"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>

                <hr className="w-50 mx-auto mt-4 mb-4" />
                <div className="form-box-title">
                  <h4>About the Company</h4>
                  <p>Tell us a little more</p>
                </div>
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formCompanySize">
                      <Form.Label>Company Type</Form.Label>
                      <Field
                        id="category"
                        name="companyType"
                        as="select"
                        className="form-select"
                      >
                        <option value="">Select Company Size</option>
                        {companytype.map((item, i) => (
                          <option value={item.value} key={i}>
                            {item.label}
                          </option>
                        ))}
                      </Field>
                      <ErrorMessage
                        name="companyType"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>

                  <Col lg={6}>
                    <Form.Group className="mb-3" controlId="formIncorporationDate">
                      <Form.Label>Incorporation Date</Form.Label>
                      <Field
                        name="incorporationDate"
                        type="date"
                        className="form-control"
                        max={new Date().toISOString().split("T")[0]}
                      />
                      <ErrorMessage
                        name="incorporationDate"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </Col>


                  {values.companyType === 'LimitedCompany' &&
                    <Col lg={6}>
                      <Form.Group className="mb-3" controlId="formCompanySize">
                        <Form.Label>Company Size</Form.Label>
                        <Field
                          id="category"
                          name="companySize"
                          as="select"
                          className="form-select"
                        >
                          <option value="">Select Company Size</option>
                          {LimitedCompanyOptions.map((item, i) => (
                            <option value={item.value} key={i}>
                              {item.label}
                            </option>
                          ))}
                        </Field>
                        <ErrorMessage
                          name="companySize"
                          component="div"
                          className="text-danger"
                        />
                      </Form.Group>
                    </Col>
                  }
                </Row>
                <Form.Group className="mb-3" controlId="formDescription">
                  <Form.Label>Company Description</Form.Label>
                  <ReactQuill
                    value={values.description}
                    onChange={(content) => setFieldValue("description", content)}
                    modules={modules} // Apply the custom toolbar
                  />
                  <ErrorMessage
                    name="description"
                    component="div"
                    className="text-danger"
                  />
                </Form.Group>
                <button type="submit" className="theme-comm-btn mt-2">
                  Save
                </button>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

export default BasicsProfile;

